import { useEffect } from "react"

import { Segmented } from "antd"
import { useDispatch, useSelector } from "react-redux"

import { setGlobalFilters } from "../../Containers/GlobalFilters/redux/globalFilters.slice"
import { PARTNER_ADMIN_ID } from "../../Utils/utils"

export const adminOptionsFiltering = [
  { value: "true", label: "Test On" },
  { value: "false", label: "Test Off" }
]

const GlobalFilterTest = ({ usersViewForAdmin, setPageNumber, size }) => {
  const dispatch = useDispatch()
  const { testData } = useSelector((state) => state.globalFilters)
  const { isAdmin, userInfo } = useSelector((state) => state.auth)

  const isAdminPage = isAdmin && !usersViewForAdmin
  const isPartnerAdmin = userInfo?.role?.id === PARTNER_ADMIN_ID
  const adminFilterOptions = isPartnerAdmin
    ? adminOptionsFiltering.filter((o) => o.label === "Test On")
    : adminOptionsFiltering

  const getToggleTestId = (value) => `test-data-toggle-${value === "true" ? "on" : "off"}`

  const handleChangeGlobalFilter = (filterData) => {
    dispatch(setGlobalFilters(filterData))
    if (typeof setPageNumber === "function") {
      setPageNumber(1)
    }
  }
  useEffect(() => {
    if (!isPartnerAdmin) return

    handleChangeGlobalFilter({ testData: "true" })
  }, [isPartnerAdmin])

  if (!isAdminPage) return null

  return (
    <Segmented
      options={adminFilterOptions.map((option) => ({
        ...option,
        label: <span data-testid={getToggleTestId(option.value)}>{option.label}</span>
      }))}
      value={testData}
      onChange={(value) => handleChangeGlobalFilter({ testData: value })}
      size={size}
    />
  )
}

export default GlobalFilterTest
